import hwpJsonKo from './ko/hwp.json';
import slideJsonKo from './ko/pptx.json';
import pdfJsonKo from './ko/pdf.json';
import wordJsonKo from './ko/docx.json';
import sheetJsonKo from './ko/sheet.json';

import hwpJsonEn from './en/hwp.json';
import slideJsonEn from './en/pptx.json';
import pdfJsonEn from './en/pdf.json';
import wordJsonEn from './en/docx.json';
import sheetJsonEn from './en/sheet.json';

export const SAMPLE_FILE_DATA = (language: string) => {
  switch (language) {
    case 'ko':
      return {
        hwp: hwpJsonKo,
        slide: slideJsonKo,
        pdf: pdfJsonKo,
        word: wordJsonKo,
        sheet: sheetJsonKo
      };
    case 'en':
    default:
      return {
        hwp: hwpJsonEn,
        slide: slideJsonEn,
        pdf: pdfJsonEn,
        word: wordJsonEn,
        sheet: sheetJsonEn
      };
  }
};
